import styled from 'styled-components';

export const Content = styled.div`
  padding: 24px 24px 32px;
  background: ${({ theme }) => theme.palette.white};
  margin-bottom: 16px;
  border-radius: 6px;
`;
